import { render } from "./AsideCartTotals.vue?vue&type=template&id=52bb57d9"
import script from "./AsideCartTotals.vue?vue&type=script&lang=js"
export * from "./AsideCartTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__